import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { DashboardUserControllerModule } from './controllers/DashboardUserController';

export const DashboardUserView = angular
  .module('acme.view.application.dashboard.user', [uiRouter, 'ui.bootstrap', DashboardUserControllerModule])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.dashboardUser',
      url: '/dashboard/user',
      views: {
        'subview-main': {
          controller: 'DashboardUserController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/dashboard/user/user.tpl.html',
        },
      },
      data: {
        pageTitle: 'Dashboard',
        roles: ['personnel'],
      },
    });
  }).name;
